<div class="invoice-editor" *ngIf="hasInvoice">

  <!-- ── Блок 1: номер и дата инвойса, загруженный файл ─────────────────────
       Из PDF подставляются автоматически; нет данных или ручной ввод — прочерк. Поля можно исправить. -->
  <section class="inv-card inv-head">
    <div class="inv-head__ids">
      <label class="inv-field inv-field--inline">
        <span class="inv-field__label inv-head__title">{{ invoiceText }} №</span>
        <input class="inline-input inline-input--strong" [(ngModel)]="head.invoiceNumber" [readonly]="readonly"
               placeholder="—" [attr.aria-label]="invoiceText + ' №'" [disabled]="saving" />
      </label>
      <label class="inv-field inv-field--inline">
        <span class="inv-field__label">{{ dateText }}</span>
        <input class="inline-input" [(ngModel)]="head.invoiceDate" [readonly]="readonly"
               placeholder="—" [attr.aria-label]="dateText" [disabled]="saving" />
      </label>
    </div>

    <div class="inv-head__file" *ngIf="calculation.invoiceFile">
      <a href="#" (click)="downloadInvoice($event)" class="invoice-download-link">
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M7 3h7l5 5v13H7z M14 3v5h5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        {{ calculation.invoiceFile.fileName }}
      </a>
      <span class="invoice-size" *ngIf="calculation.invoiceFile.fileSize">{{ formatFileSize(calculation.invoiceFile.fileSize) }}</span>
    </div>
  </section>

  <!-- ── Блок 2: стороны и условия — по тем же правилам, что блок 1 ───────── -->
  <section class="inv-card inv-terms-card" [class.inv-terms-card--collapsed]="!termsOpen">
    <!-- Блок сворачивается всегда; по умолчанию свёрнут при ручном вводе без реквизитов -->
    <button type="button" class="terms-toggle" *ngIf="termsCollapsible" (click)="termsOpen = !termsOpen" [attr.aria-expanded]="termsOpen">
      <span class="ai-toggle__sign" aria-hidden="true">{{ termsOpen ? '−' : '+' }}</span>
      <span class="terms-toggle__title">{{ termsToggleText }}</span>
    </button>
    <div class="inv-terms" *ngIf="termsOpen">
      <div class="term">
        <span class="term__label">{{ sellerText }}</span>
        <input class="inline-input inline-input--strong" [(ngModel)]="head.sellerName" [readonly]="readonly"
               placeholder="—" [attr.aria-label]="sellerText" [disabled]="saving" />
        <textarea class="inline-input inline-input--detail" rows="1" [(ngModel)]="head.sellerAddress" [readonly]="readonly"
               [placeholder]="readonly ? '' : addressPlaceholderText" [attr.aria-label]="sellerText + ': ' + addressPlaceholderText" [disabled]="saving"></textarea>
        <p class="term__detail" *ngIf="invoiceData?.sellerEmail">{{ invoiceData!.sellerEmail }}</p>
        <p class="term__detail" *ngIf="invoiceData?.sellerTaxId">{{ taxIdText }} {{ invoiceData!.sellerTaxId }}</p>
      </div>
  
      <div class="term">
        <span class="term__label">{{ buyerText }}</span>
        <input class="inline-input inline-input--strong" [(ngModel)]="head.buyerName" [readonly]="readonly"
               placeholder="—" [attr.aria-label]="buyerText" [disabled]="saving" />
        <textarea class="inline-input inline-input--detail" rows="1" [(ngModel)]="head.buyerAddress" [readonly]="readonly"
               [placeholder]="readonly ? '' : addressPlaceholderText" [attr.aria-label]="buyerText + ': ' + addressPlaceholderText" [disabled]="saving"></textarea>
        <p class="term__detail" *ngIf="invoiceData?.buyerEmail">{{ invoiceData!.buyerEmail }}</p>
        <p class="term__detail" *ngIf="invoiceData?.buyerTaxId">{{ taxIdText }} {{ invoiceData!.buyerTaxId }}</p>
      </div>
  
      <div class="term">
        <span class="term__label">{{ paymentTermsLabelText }}</span>
        <input class="inline-input" [(ngModel)]="head.paymentTerms" [readonly]="readonly"
               placeholder="—" [attr.aria-label]="paymentTermsLabelText" [disabled]="saving" />
      </div>
  
      <div class="term">
        <span class="term__label">{{ incotermsLabelText }}</span>
        <select *ngIf="!readonly; else incotermReadonlyView" class="inline-select" [(ngModel)]="editIncoterm"
                [attr.aria-label]="incotermsLabelText" [disabled]="saving">
          <option value="">—</option>
          <option *ngFor="let incoterm of incoterms" [value]="incoterm.code">{{ getIncotermLabel(incoterm) }}</option>
        </select>
        <ng-template #incotermReadonlyView>
          <span class="term__value">{{ calculation.incotermCode || '—' }}</span>
        </ng-template>
        <span class="term__hint" *ngIf="calculation.incotermFromInvoice && editIncoterm === (calculation.incotermCode || '')">✓ {{ incotermFromInvoiceHintText }}</span>
      </div>
    </div>
  </section>

  <!-- ── Блок 3: позиции инвойса — всё редактирует пользователь ──────────── -->
  <section class="inv-card invoice-items">
    <button type="button" class="terms-toggle items-toggle" (click)="itemsOpen = !itemsOpen" [attr.aria-expanded]="itemsOpen">
      <span class="ai-toggle__sign" aria-hidden="true">{{ itemsOpen ? '−' : '+' }}</span>
      <span class="terms-toggle__title invoice-items__title">{{ itemsTitleText }}</span>
      <span class="items-toggle__count">{{ rows.length }}</span>
    </button>

    <div class="items-body" *ngIf="itemsOpen">

      <!-- Данные распознаёт ИИ — просим проверить и поправить -->
      <div class="ai-notice" role="note">
        <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 9v4.5M10 6.3v.2"/></svg>
        <p><strong>{{ aiNoticeTitleText }}</strong> {{ itemsHintText }}</p>
      </div>

      <div class="invoice-table-wrap">
        <table class="invoice-table">
          <thead>
            <tr>
              <th class="col-num">{{ columnNumText }}</th>
              <th class="col-name">{{ columnNameText }}</th>
              <th class="col-unit">{{ columnUnitText }}</th>
              <th class="col-qty">{{ columnQtyText }}</th>
              <th class="col-price">{{ columnPriceText }}</th>
              <th class="col-total">{{ columnTotalText }}</th>
              <th class="col-tnved">{{ columnTnvedText }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows; let i = index">
              <td class="col-num" [attr.data-label]="columnNumText">{{ (row.invoiceItem?.lineNumber ?? i + 1) }}</td>
              <td class="col-name">
                <div class="name-wrap">
                  <!-- Длинное наименование свёрнуто до двух строк; клик по тексту раскрывает для правки -->
                  <button type="button" class="name-preview" *ngIf="isLongName(row) && !row.nameOpen; else nameEditor"
                          (click)="openName(row, i)" [attr.aria-label]="columnNameText + ': ' + expandText"><span>{{ row.editName }}</span></button>
                  <ng-template #nameEditor>
                    <textarea class="edit-input edit-input--name" rows="1" [id]="'inv-name-' + i" [(ngModel)]="row.editName"
                              [attr.aria-label]="columnNameText" [disabled]="saving || viewOnly"></textarea>
                  </ng-template>
                  <button type="button" class="name-toggle" *ngIf="isLongName(row)" (click)="row.nameOpen = !row.nameOpen"
                          [class.name-toggle--open]="row.nameOpen" [attr.aria-expanded]="row.nameOpen"
                          [attr.aria-label]="row.nameOpen ? collapseText : expandText" [title]="row.nameOpen ? collapseText : expandText">
                    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 7.5l5 5 5-5"/></svg>
                  </button>
                </div>
                <!-- Описание (по нему подбирается код ТН ВЭД) и вывод ИИ — свёрнуты под «+» -->
                <ng-container *ngIf="row.product.applicationScope || row.product.aiProductDescription">
                  <button type="button" class="ai-toggle" (click)="row.aiOpen = !row.aiOpen" [attr.aria-expanded]="row.aiOpen">
                    <span class="ai-toggle__sign" aria-hidden="true">{{ row.aiOpen ? '−' : '+' }}</span>
                    {{ descriptionToggleText }}
                  </button>
                  <div class="product-details" *ngIf="row.aiOpen">
                    <p class="product-scope" *ngIf="row.product.applicationScope">{{ row.product.applicationScope }}</p>
                    <div class="product-ai" *ngIf="row.product.aiProductDescription">{{ aiIdentifiedAsText }}: {{ row.product.aiProductDescription }}</div>
                  </div>
                </ng-container>
              </td>
              <td class="col-unit" [attr.data-label]="columnUnitText">
                <input type="text" class="edit-input edit-input--unit" [(ngModel)]="row.editUnit" placeholder="—"
                       [attr.aria-label]="columnUnitText" [disabled]="saving || viewOnly" />
              </td>
              <td class="col-qty" [attr.data-label]="columnQtyText">
                <input type="number" class="edit-input edit-input--qty" [(ngModel)]="row.editQty" (ngModelChange)="onQtyOrPriceChange(row)"
                       min="0" step="any" placeholder="—" [attr.aria-label]="columnQtyText" [disabled]="saving || viewOnly" />
              </td>
              <td class="col-price" [attr.data-label]="columnPriceText">
                <input type="number" class="edit-input edit-input--price" [(ngModel)]="row.editUnitPrice" (ngModelChange)="onQtyOrPriceChange(row)"
                       min="0" step="0.01" placeholder="—" [attr.aria-label]="columnPriceText" [disabled]="saving || viewOnly" />
              </td>
              <td class="col-total" [attr.data-label]="columnTotalText">
                <div class="edit-field">
                  <input
                    type="number"
                    class="edit-input edit-input--cost"
                    [(ngModel)]="row.editCost"
                    min="0"
                    step="0.01"
                    [attr.aria-label]="columnTotalText"
                    [disabled]="saving || viewOnly"
                  />
                  <select class="edit-select" [(ngModel)]="row.editCurrency" [disabled]="saving || viewOnly">
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="CNY">CNY</option>
                    <option value="KZT">KZT</option>
                  </select>
                </div>
              </td>
              <td class="col-tnved" [attr.data-label]="columnTnvedText">
                <div class="tnved-autocomplete">
                  <input
                    type="text"
                    class="edit-input edit-input--tnved"
                    [(ngModel)]="row.editTnved"
                    [placeholder]="tnvedPlaceholderText"
                    (input)="onTnvedInput(row, i, row.editTnved)"
                    (blur)="hideSuggestions(row)"
                    [attr.aria-label]="columnTnvedText"
                    [disabled]="saving || viewOnly"
                    autocomplete="off"
                  />
                  <ul class="tnved-dropdown" *ngIf="row.showSuggestions">
                    <li
                      *ngFor="let s of row.tnvedSuggestions"
                      (mousedown)="selectTnved(row, s)"
                      class="tnved-dropdown__item"
                      [class.tnved-dropdown__item--10]="s.is10"
                    >
                      <span class="tnved-code">{{ s.code }}</span>
                      <span class="tnved-name">{{ s.name }}</span>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Сохранить / отменить — для всех трёх блоков сразу -->
    <div class="invoice-actions">
      <button type="button" class="btn-save" *ngIf="!viewOnly" (click)="save()" [disabled]="saving || rows.length === 0">
        <span *ngIf="!saving && !saved">{{ saveText }}</span>
        <span *ngIf="saving">{{ savingText }}</span>
        <span *ngIf="saved">{{ savedText }}</span>
      </button>
      <button type="button" class="btn-cancel" *ngIf="!viewOnly" (click)="cancelEditing()" [disabled]="saving || !isDirty">
        {{ cancelEditingText }}
      </button>
      <!-- Итог по суммам позиций — пересчитывается сразу при правке; разные валюты — через «+» -->
      <div class="invoice-total" *ngIf="invoiceTotals.length">
        <span class="invoice-total__label">{{ invoiceTotalText }}</span>
        <strong class="invoice-total__value">{{ invoiceTotalsLabel }}</strong>
      </div>
      <div *ngIf="globalError" class="row-error" role="alert">{{ globalError }}</div>
      <div *ngIf="notSaved" class="row-warning" role="status">{{ headerNotSavedText }}</div>
    </div>
  </section>
</div>
